import { useFormContext } from 'react-hook-form';
import { Button, ButtonSubmit, Form } from '@anytag/shared-atoms';
import { useAllAvailableCountryOptions, useQueryHelper, useToggle } from '@anytag/shared-hooks';
import { TextField, PasswordField, SelectorField, SwitchToggleField } from '@anytag/shared-molecules';
import { cn, isThailandCountry } from '@anytag/shared-utils';
import { TikTokSettingsFormKeys, TikTokSettingsFormValues } from './types';

export interface TikTokSettingsTemplateFormProps {
  onOpenPasswordModal: () => void;
}
export const Template = ({ onOpenPasswordModal }: TikTokSettingsTemplateFormProps) => {
  const modalState = useToggle();
  const { t } = useQueryHelper();
  const { allAvailableCountryOptions } = useAllAvailableCountryOptions();
  const {
    formState: { isSubmitting }
  } = useFormContext<TikTokSettingsFormValues>();

  return (
    <>
      <Form.Body>
        <Form.SectionTitle label={t('Company Information')} className="font-semibold" />

        <TextField<TikTokSettingsFormKeys>
          name="advertiserName"
          placeholder="AnyMindgroup"
          title={t('TextForm.Company Name')}
          required
        />

        <TextField<TikTokSettingsFormKeys>
          name="advertiserCompanyUrl"
          title={t('TextForm.Company URL')}
          placeholder="https://anytag.tech"
          required
        />

        <Form.Fields>
          <TextField<TikTokSettingsFormKeys>
            placeholder="03-1111-1111"
            name="advertiserPhoneNumber"
            title={t('TextForm.Phone Number')}
            required
          />

          <SelectorField<TikTokSettingsFormKeys>
            name="advertiserCountryId"
            title={t('Selector.Country')}
            required
            // // https://adasiaholdings.atlassian.net/wiki/spaces/NC/pages/3567255574/Onboarding+process+for+TikTok+collab+service#%E2%91%A0Add-information
            disabled
            options={allAvailableCountryOptions.filter((option) => isThailandCountry(option.value))}
          />
        </Form.Fields>

        <Form.SectionTitle className="mt-10" label={t('User Information')} />

        <TextField<TikTokSettingsFormKeys> name="name" title={t('TextForm.Name')} placeholder="Naoya Kurita" required />

        <Form.Fields>
          <TextField<TikTokSettingsFormKeys>
            name="email"
            placeholder="myemail@gmail.com"
            title={t('TextForm.Email Address')}
            required
          />

          <SelectorField<TikTokSettingsFormKeys>
            name="countryId"
            title={t('Selector.Country')}
            options={allAvailableCountryOptions}
            required
          />
        </Form.Fields>

        <Form.Fields className="items-end">
          <PasswordField<TikTokSettingsFormKeys>
            name="password"
            title={t('TextForm.Password')}
            placeholder={t<string>('Password.Your Password')}
            required
            disabled
          />

          <Form.Field className="flex-1">
            <Button
              variant="outline"
              onClick={onOpenPasswordModal}
              title={t('Button.Change Password')}
              className={cn('px-6 uppercase', { 'opacity-0': modalState.on })}
            />
          </Form.Field>
        </Form.Fields>

        <SwitchToggleField<TikTokSettingsFormKeys>
          name="notificationSetting"
          title={t('TextForm.Notification Settings')}
          help={t('Tooltip.Notification for Advertiser settings help')}
        />
      </Form.Body>

      <Form.Footer>
        <ButtonSubmit title={t('Button.Save')} loading={{ status: isSubmitting, title: t('Button.Saving') }} />
      </Form.Footer>
    </>
  );
};
